import { render, staticRenderFns } from "./FichaDetalleForm.vue?vue&type=template&id=633f78a4&"
import script from "./FichaDetalleForm.vue?vue&type=script&lang=js&"
export * from "./FichaDetalleForm.vue?vue&type=script&lang=js&"
import style0 from "./FichaDetalleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports